import React, { memo, useState } from 'react';
import {
  Stack,
  Typography,
  Tabs,
  Tab,
  ToggleButtonGroup,
  ToggleButton
} from 'investira.react.components';
import { AVALIACAO_SESSOES_QUESTOES, AVALIACAO_SESSOES } from '../../../../enums';
import AvaliacoesOutputRespostasAvaliacao from './AvaliacoesOutputRespostasAvaliacao';
import { validators } from 'investira.sdk';

const AvaliacoesOutputRespostas = memo(props => {
  const { data: externalData } = props;
  const [categoria, setCategoria] = useState(0);
  const [tipoFiltro, setTipoFiltro] = useState('apenas_justificativas');

  const xSessoesQuestoes = Object.values(AVALIACAO_SESSOES_QUESTOES)[categoria];
  const xQuestoes = xSessoesQuestoes.questoes;

  const hasExternalData = Array.isArray(externalData) && externalData.length > 0;

  const xQuestoesMocked = hasExternalData
    ? externalData
    : xQuestoes
        .map((xQuestao, xIndex) => {
          const xNota = Math.round(Math.random() * 3);
          const xHasJustificativa = xIndex % 2 === 0;
          const xHasAlteracaoNota = xHasJustificativa && xIndex % 4 === 0;
          const xNotaGestor = xHasJustificativa
            ? xHasAlteracaoNota
              ? Math.max(0, Math.min(3, xNota - 1))
              : xNota
            : null;

          const xDataMock = {
            ...xQuestao,
            resposta_gestor: `Resposta do gestor para a questão "${xQuestao.questao}".`,
            nota_gestor: xNotaGestor,
            houve_alteracao_nota: xHasAlteracaoNota,
            justificativa: xHasJustificativa
              ? xHasAlteracaoNota
                ? 'A entidade revisou esta resposta e ajustou o rating com base em evidências complementares analisadas na etapa de avaliação.'
                : 'A entidade revisou esta resposta e manteve a nota/rating, registrando justificativa para rastreabilidade.'
              : null
          };
          return xDataMock;
        })
        .filter(xQuestao => !validators.isNull(xQuestao.justificativa));

  const xQuestoesFiltradas = xQuestoesMocked.filter(xQuestao =>
    tipoFiltro === 'notas_alteradas'
      ? xQuestao.houve_alteracao_nota
      : !xQuestao.houve_alteracao_nota
  );

  return (
    <Stack direction="row" gap={4}>
      <Stack sx={{ minWidth: '200px', maxWidth: '340px', width: '100%' }}>
        <Tabs
          value={categoria}
          onChange={(e, v) => setCategoria(v)}
          orientation="vertical"
          variant="scrollable"
          sx={{ borderRight: 1, borderColor: 'divider', textAlign: 'left' }}>
          {Object.values(AVALIACAO_SESSOES).map(xSessao => {
            const { sessao, label } = xSessao;
            return (
              <Tab key={sessao} label={label} sx={{ textAlign: 'right', alignItems: 'end' }} />
            );
          })}
        </Tabs>
      </Stack>
      <Stack gap={3} flexGrow={1}>
        {/* <ToggleButtonGroup value={tipoFiltro} size="small" color="primary">
          <ToggleButton value="notas_alteradas" onClick={() => setTipoFiltro('notas_alteradas')}>
            Notas alteradas
          </ToggleButton>
          <ToggleButton
            value="apenas_justificativas"
            onClick={() => setTipoFiltro('apenas_justificativas')}>
            Apenas justificativas
          </ToggleButton>
        </ToggleButtonGroup> */}
        <Stack gap={1}>
          <Stack mb={1}>
            <Typography color="textPrimary" variant="h6">
              {xQuestoes[categoria].categoria}
            </Typography>
          </Stack>

          <Stack gap={4}>
            {xQuestoesFiltradas.map((xQuestao, xIndex) => {
              const xNota = hasExternalData
                ? (xQuestao.nota_gestor ?? xQuestao.nota ?? 0)
                : Math.round(Math.random() * 4);
              const { sessao } = xQuestao;

              return (
                <AvaliacoesOutputRespostasAvaliacao
                  data={xQuestao}
                  nota={xNota}
                  variant="justificativa"
                  aliasQuestionId={`${sessao}.${xIndex + 1}`}
                />
              );
            })}
          </Stack>
        </Stack>
      </Stack>
      <Stack sx={{ minWidth: '200px', maxWidth: '340px', width: '100%' }}></Stack>
    </Stack>
  );
});

export default AvaliacoesOutputRespostas;
